export const SOCIAL_LINKS = {
  whatsapp: 'https://wa.me/+79230377918',
  telegram: 'https://t.me/+79230377918',
  privacyPolicy: '',
};
